import { useContext } from "react";
import { Link } from "react-router";
import { useQuery } from "@tanstack/react-query";
import { ArrowRight, CheckCircle } from "@phosphor-icons/react";
import { UnitContext } from "../../contexts/contextExporter";
import { qoHomeCurrent } from "../../utils/queryOptions";
import { useSqids } from "../../hooks/useSqids";
import { slugify } from "../../utils/urlConversion";
import { contentPaths } from "../../utils/static";
import LoadingScreen from "../../components/LoadingScreen";

// Dersin son bölümü de bitince gösterilir. Sıradaki dersi home/current'tan alır:
// biten ders "Devam Et" hedefi olmaktan çıktığı için resumeUnitId sıradaki derstir.
export default function UnitFinished() {
  const { unit } = useContext(UnitContext);
  const sqids = useSqids();

  // Son sorunun skoru az önce yazıldı; cache'teki eski hedefi göstermemek için taze çek.
  const { data: home, isFetchedAfterMount } = useQuery({
    ...qoHomeCurrent(),
    staleTime: 0,
    refetchOnMount: "always",
  });

  if (!isFetchedAfterMount) {
    return <LoadingScreen text="Yükleniyor..." />;
  }

  const hasNextUnit =
    !!home?.resumeUnitId &&
    !!home.resumeUnitName &&
    home.resumeUnitId !== unit?.module_cohort_content_id;

  return (
    <div className="flex-1 flex items-center justify-center px-4">
      <div className="bg-surface-1 border border-white/[0.08] rounded-2xl max-w-md p-10 w-full text-center">
        <CheckCircle size={44} weight="fill" className="text-myGreen mx-auto" />
        <div className="text-2xl text-white font-semibold mt-4">
          Dersin sonuna geldin
        </div>
        <div className="text-sm text-white/40 mt-2 leading-relaxed">
          {unit?.name}
        </div>

        {hasNextUnit ? (
          <>
            <Link
              to={`/${contentPaths.UNIT}/${slugify(home!.resumeUnitName!)}-${sqids.encode(home!.resumeUnitId!)}`}
              className="mt-8 px-5 py-2.5 bg-myGreen hover:bg-myGreen/80 rounded-xl text-black text-sm font-semibold transition-colors inline-flex items-center gap-2"
            >
              Sıradaki ders: {home!.resumeUnitName}
              <ArrowRight size={16} weight="bold" />
            </Link>
            <div className="mt-4">
              <Link
                to="/"
                className="text-sm text-white/40 hover:text-white/70 transition-colors"
              >
                Ana sayfaya dön
              </Link>
            </div>
          </>
        ) : (
          <Link
            to="/"
            className="inline-block mt-8 px-5 py-2.5 bg-myBlue hover:bg-myBlue/80 rounded-xl text-white text-sm font-semibold transition-colors"
          >
            Ana sayfaya dön
          </Link>
        )}
      </div>
    </div>
  );
}
